import { useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import TermsContent from '@/components/terms-content';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  scrollToSection?: string;
}

export default function TermsModal({ isOpen, onClose, scrollToSection }: TermsModalProps) {
  // Handle scrolling to specific section when modal opens
  useEffect(() => {
    if (isOpen && scrollToSection) {
      // Small delay to ensure modal content is rendered
      setTimeout(() => {
        const element = document.getElementById(scrollToSection);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
      }, 100);
    }
  }, [isOpen, scrollToSection]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[85vh] p-0 flex flex-col">
        <div className="min-h-0 flex-1 overflow-y-auto">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle className="font-semibold tracking-tight text-foreground text-center uppercase text-[40px]" style={{ fontFamily: 'Lato', fontWeight: '300' }}>Terms and Conditions</DialogTitle>
          <DialogDescription className="text-foreground text-center">
            Please read these terms and conditions carefully before making a booking with Toka Ridge.
          </DialogDescription>
        </DialogHeader>
        
        <div className="px-6 pb-6">
          <TermsContent headingTag="h3" />
        </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
